import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/stores', { params })
}

/**
 * @param id
 */
export const show = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/stores/${id}`, { params })
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateAttribute = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/stores/${id}/attribute`, params)
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const qrcode = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/stores/${id}/qrcode`, { params })
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const exportDramas = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/stores/${id}/dramas`, { params, responseType: 'blob' })
}

export const authUrl = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/stores/${id}/auth`)
}

export const submitReview = (id: number, params = {}): AxiosPromise => {
  return axios.post(`/stores/${id}/submited`)
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateExpiredAt = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/stores/${id}/expired_at`, params)
}

/**
 * @param id
 */
export const destroy = (id: number): AxiosPromise => {
  return axios.delete(`/stores/${id}`)
}
